module.exports = __webpack_public_path__ + "assets/transcript_editing.png";